import React from 'react';
import { motion } from 'framer-motion';
import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';
function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
interface SectionProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
  background?: 'dark' | 'navy' | 'gradient';
  delay?: number;
}
export function Section({
  children,
  className,
  id,
  background = 'dark',
  delay = 0
}: SectionProps) {
  const backgrounds = {
    dark: 'bg-[#0f1419]',
    navy: 'bg-[#1a1f2e]',
    gradient: 'bg-gradient-to-b from-[#0f1419] to-[#1a1f2e]'
  };
  return <section id={id} className={cn('py-16 md:py-24 px-4 sm:px-6 lg:px-8 relative overflow-hidden', backgrounds[background], className)} data-id="element-214">
      {background === 'gradient' && <div className="absolute inset-0 opacity-10 pointer-events-none" data-id="element-215">
          <svg className="w-full h-full" viewBox="0 0 100 100" preserveAspectRatio="none" data-id="element-216">
            <path d="M0 50 Q 25 60 50 50 T 100 50 V 100 H 0 Z" fill="#d4af37" data-id="element-217" />
            <path d="M0 60 Q 25 70 50 60 T 100 60 V 100 H 0 Z" fill="#d4af37" opacity="0.5" data-id="element-218" />
          </svg>
        </div>}

      <motion.div initial={{
      opacity: 0,
      y: 30
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.6,
      delay,
      ease: 'easeOut'
    }} className="max-w-4xl mx-auto relative z-10" data-id="element-219">
        {children}
      </motion.div>
    </section>;
}